import { render } from "./ServicePricingCarousel.vue?vue&type=template&id=04e8fb84&scoped=true"
import script from "./ServicePricingCarousel.vue?vue&type=script&lang=js"
export * from "./ServicePricingCarousel.vue?vue&type=script&lang=js"

import "./ServicePricingCarousel.vue?vue&type=style&index=0&id=04e8fb84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e8fb84"]])

export default __exports__